import { gql, useQuery } from "@apollo/client";
import { Alert, Form, Select } from "antd";
import { SelectOptionDetails } from "./SelectOptionDetails";

export const GET_PM_PLUS_ACCOUNT_DETAILS = gql`
  query GetPmPlusAccountDetails {
    paymentsManagerPlusAccountDetails(isActive: true) {
      MerchantId
      BusinessName
      IsActive
      OwnerEmail
      HeartlandMerchantId
      MerchantSubdomain
      DBA
    }
  }
`;

type PmPlusAccountDetails = {
  MerchantId: number;
  BusinessName: string;
  IsActive: boolean;
  OwnerEmail: string;
  HeartlandMerchantId: string;
  MerchantSubdomain: string;
  DBA: string;
};

export const PmPlusSourceOptions = () => {
  const { data, loading, error } = useQuery<{
    paymentsManagerPlusAccountDetails: PmPlusAccountDetails[];
  }>(GET_PM_PLUS_ACCOUNT_DETAILS);

  return (
    <>
      {error && (
        <Alert
          message="Error fetching PM+ account details, please try again."
          type="error"
        />
      )}
      <Form.Item
        key="sourceSchemaName"
        name="sourceSchemaName"
        label="PM+ Account"
        rules={[{ required: true }]}
      >
        <Select
          showSearch
          loading={loading}
          placeholder="Search for merchant"
          optionFilterProp="search"
          disabled={!!error}
          options={data?.paymentsManagerPlusAccountDetails.map((account) => ({
            ...account,
            search: [
              account.MerchantId,
              account.MerchantSubdomain,
              account.BusinessName,
              account.OwnerEmail,
              account.HeartlandMerchantId,
              account.DBA,
            ].join(" "),
            value: account.DBA,
          }))}
          optionRender={({ data }) => (
            <SelectOptionDetails
              titleLabel="Account"
              titleKey="MerchantSubdomain"
              fields={{
                Name: "BusinessName",
                Email: "OwnerEmail",
                "Merchant ID": "HeartlandMerchantId",
                DBA: "DBA",
              }}
              data={data}
            />
          )}
        />
      </Form.Item>
    </>
  );
};
